import { z } from 'zod'

export const inviteUserSchema = z.object({
  email: z.email('settings:teamSettings.inviteDialog.emailRequired'),
  firstName: z.string().min(1, 'settings:teamSettings.inviteDialog.firstNameRequired'),
  lastName: z.string().min(1, 'settings:teamSettings.inviteDialog.lastNameRequired'),
  role: z.enum(['ADMIN', 'MANAGER', 'STAFF']),
})

export type InviteUserFormValues = z.infer<typeof inviteUserSchema>

export const defaultInviteValues: InviteUserFormValues = {
  email: '',
  firstName: '',
  lastName: '',
  role: 'STAFF',
}

export const INVITABLE_ROLES = ['ADMIN', 'MANAGER', 'STAFF'] as const
